export const GET_ROLES = "GET_ROLES";

export const GetRoles = () => {
    return { type: GET_ROLES };
};
